import { SciDomainsPage } from 'features/sci-domains';

export const AdminSciDomainsPage: React.FC = () => <SciDomainsPage />;
